import React from 'react'
import {RadioInputView, StyledRadio, RadioCheckmark} from './RadioStyles'

const RadioInput = ({children, inline = true, disabled, ...props}) => (
  <RadioInputView inline={inline} disabled={disabled}>
    {children}
    <StyledRadio disabled={disabled} {...props} />
    <RadioCheckmark disabled={disabled} {...props} />
  </RadioInputView>
)

export default RadioInput
